import React, { type PropsWithChildren } from 'react';

import { NoticeBannersStackProvider } from '@garnish/overlays';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useIsLiquidGlassEnabled } from '../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const NoticeBannersProvider = (props: PropsWithChildren) => {
  const { children } = props;

  const isToastEnabled = useFeatureFlag('CELS-6140-order-toast-notifications-enabled');
  const isLiquidGlassEnabled = useIsLiquidGlassEnabled();

  return (
    <NoticeBannersStackProvider
      variant={isToastEnabled ? 'toast' : 'banner'}
      isLiquidGlassEnabled={isLiquidGlassEnabled}
    >
      {children}
    </NoticeBannersStackProvider>
  );
};
